import ENDPOINTS from 'api/endpoints';
import { doGet, doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type {
  MCPProviderCatalogItem,
  MCPServer,
  MCPToolDefinition,
} from 'screens/Integrations/types/mcp';

export interface DiscoverMCPToolsParams {
  accountId: string;
  projectId: string;
  server: MCPServer;
  forceRefresh?: boolean;
}

export interface DiscoverMCPToolsResponse {
  tools: MCPToolDefinition[];
}

export interface MCPToolsCatalogResponse {
  providers: MCPProviderCatalogItem[];
}

export const discoverMcpTools = ({
  accountId,
  projectId,
  server,
  forceRefresh = false,
}: DiscoverMCPToolsParams) => {
  const url = generateNextPath(ENDPOINTS.MCP_TOOLS_DISCOVER, {
    accountId,
    projectId,
  });

  return doPost<DiscoverMCPToolsResponse>(
    url,
    LOGGER_TYPE.JUPITER,
    {
      server,
      force_refresh: forceRefresh,
    },
    {
      version: 'v2',
    },
  );
};

export const getMcpToolsCatalog = ({
  accountId,
  projectId,
}: {
  accountId: string;
  projectId: string;
}) => {
  const url = generateNextPath(ENDPOINTS.MCP_TOOLS_CATALOG, {
    accountId,
    projectId,
  });

  return doGet<MCPToolsCatalogResponse>(url, LOGGER_TYPE.JUPITER, {
    version: 'v2',
  });
};
